import React, { useCallback, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Elements } from 'react-stripe-elements';
import PropTypes from 'prop-types';
import './AddUserToTeamPopup.css';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import FormSelectSearchField from '../../postCreationForm/formSelectSearchField/FormSelectSearchField';
import { useSelector } from '../../../hooks/useSelector';
import SelectedList from '../../postCreationForm/selectedList/SelectedList';
import { useActions } from '../../../hooks/useActions';

const initialState = {
    teams: [],
};

const validationSchema = yup.object().shape({
    teams: yup.array().min(1),
});

const AddUserToTeamPopup = ({ isOpen, handleToggle, userEmail }) => {
    const teams = useSelector(state => state.invitePeople.allUserTeams);
    const { fetchUserTeams, addUserToTeams } = useActions();

    const availableTeams = useMemo(
        () => teams.filter(team => !team.invitedUsers.includes(userEmail)),
        [userEmail, teams]
    );

    const handleSubmit = useCallback(
        async data => {
            const callback = async () => {
                await fetchUserTeams();
                handleToggle();
            };
            const selectedTeams = availableTeams.filter(team =>
                data.teams.find(selectedTeam => selectedTeam.uid === team.uid)
            );
            await addUserToTeams({ teams: selectedTeams, userEmail, callback });
        },
        [handleToggle, addUserToTeams, fetchUserTeams, availableTeams, userEmail]
    );

    return (
        <div>
            <Modal isOpen={isOpen} toggle={handleToggle} className="addToTeamPopup">
                <ModalHeader className="add-portfolio-header" toggle={handleToggle}>
                    Add User To Team
                </ModalHeader>
                <ModalBody>
                    <Elements>
                        <Formik
                            initialValues={initialState}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ values, errors, setValues, isSubmitting }) => {
                                return (
                                    <Form className="form-wrap">
                                        <div className="modal-field">
                                            <FormSelectSearchField
                                                name="teams"
                                                searchHeader="Search new team"
                                                header="Teams"
                                                headerWithSearch="Invite Team"
                                                list={availableTeams}
                                                values={values}
                                                setValues={setValues}
                                                isFullWidth
                                            />
                                            {!!values.teams.length && (
                                                <SelectedList
                                                    isHorizontal
                                                    name="teams"
                                                    field="selectedList"
                                                    items={values.teams}
                                                    values={values}
                                                    setValues={setValues}
                                                />
                                            )}
                                            {errors.teams && (
                                                <p className="note-error">Pick at least 1 team</p>
                                            )}
                                        </div>
                                        <div className="portfolio-modal-footer">
                                            <button
                                                disabled={isSubmitting}
                                                type="submit"
                                                className="add-portfolio-submit-btn with-portfolio"
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </Elements>
                </ModalBody>
            </Modal>
        </div>
    );
};

AddUserToTeamPopup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleToggle: PropTypes.func.isRequired,
    userEmail: PropTypes.string.isRequired,
};

export default AddUserToTeamPopup;
